import axios from 'axios';
const actions = {
  async getProchipDropdownValues(context) {
    const getProchipDropdownValuesEndpoint = process.env.VUE_APP_URL + '/ProchipLicense/Design';
    const response = await axios.get(getProchipDropdownValuesEndpoint);
    if(response.status === 200) {
      context.commit('setProchipDropdownValues', await response.data);
    } else {
      const error = new Error(response.message);
      throw error;
    }
  },
  async updateProchipFormData(context, payload) {
    const prochipPostEndpoint = process.env.VUE_APP_URL +  '/ProchipLicense';
    const response = await axios.post(prochipPostEndpoint, payload).catch(function () {
      context.commit('setAPIError', true);
    });
    if(response?.status === 202 || response?.status === 201 || response?.status === 200) {
      context.commit('setDBUpdateStatus', await response.data);
      context.commit('setAPIError', false);
      // eslint-disable-next-line no-undef
      $("#prochip-success-modal").modal('show');
    } else {
      context.commit('setAPIError', true);
    }
  },
  async resetDBResponse(context) {
    context.commit('resetDBResponse', {});
  },
   //ActionTypes.UPDATE_ACCESS_TOKEN in JS
  updateAccessToken({ commit }, accessToken) {
    commit('setAccessToken', accessToken); // <-- assumes mutation is named 'setAccessToken'
  },
  // getUserProfileDetails action
  async getUserProfileDetails(context) {
    const userProfileDetailsEndpoint = process.env.VUE_APP_SSO_PROFILE_URL + 'SecuredUser/GetUserProfile';

    try {
      const response = await axios.get(userProfileDetailsEndpoint);
      if (response.status === 200) {
        context.commit('setUserProfileDetails', response.data); // <-- assumes mutation is named 'setUserProfileDetails'
      } else {
        const error = new Error(response.message);
        throw error;
      }
    } catch (error) {
      console.error(error);
      const errorLog = {
        error: true,
        status: error.response?.status,
        statusText: error.response?.statusText,
        message: error.message,
        code: error.code
      };
      context.commit('setUserProfileDetails', errorLog);
    }
  }
};

export default actions;